export default __webpack_public_path__ + "images/UL.8b62164.png";